module.exports = __webpack_public_path__ + "static/img/AjlaTomljanovic.724c311.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AjlaTomljanovic.jpg
// module id = gL1S
// module chunks = 0